import { Link, NavLink } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { useState } from "react";
import { PHONE, PHONE_HREF } from "@/lib/api";

const nav = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/track", label: "Track Job" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-[#0D0E11]/95 backdrop-blur border-b border-[#2A2F3A]">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <div className="w-10 h-10 sm:w-11 sm:h-11 bg-red-600 flex items-center justify-center rounded-sm border-2 border-red-500/60">
            <span className="font-display font-black text-white text-xl">CH</span>
          </div>
          <div className="hidden sm:block leading-tight">
            <div className="font-display font-black uppercase tracking-wider text-white text-lg">Childress Hydraulics</div>
            <div className="text-[10px] font-mono-tech tracking-widest text-red-500 uppercase">Greensburg, KY</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {nav.map(n => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-display uppercase tracking-wider text-sm font-bold ${isActive ? "text-red-500" : "text-slate-200 hover:text-red-500"}`
              }
            >{n.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a
            href={PHONE_HREF}
            data-testid="call-now-button"
            className="hidden sm:inline-flex items-center gap-2 btn-red px-4 py-3 rounded-sm"
          >
            <Phone className="w-4 h-4" /> {PHONE}
          </a>
          <a href={PHONE_HREF} data-testid="call-now-mobile" className="sm:hidden inline-flex items-center btn-red px-3 py-3 rounded-sm">
            <Phone className="w-5 h-5" />
          </a>
          <button
            onClick={() => setOpen(v => !v)}
            data-testid="mobile-menu-toggle"
            className="md:hidden inline-flex items-center btn-outline px-3 py-3 rounded-sm"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#2A2F3A] bg-[#0D0E11]" data-testid="mobile-menu">
          <div className="px-4 py-3 flex flex-col gap-3">
            {nav.map(n => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `font-display uppercase tracking-wider text-base font-bold ${isActive ? "text-red-500" : "text-slate-200"}`}
              >{n.label}</NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}

export function Footer() {
  return (
    <footer className="mt-24 border-t border-[#2A2F3A] bg-[#0D0E11]">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="font-display font-black text-2xl uppercase tracking-wider text-white">Childress Hydraulics</div>
          <p className="mt-2 text-slate-400 text-sm">From Farm to Jobsite, We Keep You Working.</p>
        </div>
        <div>
          <div className="eyebrow mb-2">Contact</div>
          <a href={PHONE_HREF} className="block text-white text-lg font-display font-bold">{PHONE}</a>
          <div className="text-slate-400 text-sm">Greensburg, KY 42743</div>
        </div>
        <div>
          <div className="eyebrow mb-2">Hours</div>
          <div className="text-slate-300 text-sm">Mon–Fri • 6:30a – 5:30p</div>
          <div className="text-slate-300 text-sm">Sat • By appointment</div>
          <div className="text-red-500 text-sm mt-1 font-semibold">24/7 Emergency Line</div>
        </div>
      </div>
      <div className="border-t border-[#2A2F3A] py-4 text-center text-slate-500 text-xs">
        © {new Date().getFullYear()} Childress Hydraulics. All rights reserved.
      </div>
    </footer>
  );
}

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0D0E11]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
